import React from 'react';

import Prompt from 'components/Prompt';

const UploadOfferConfirmation = ({ sale, t }) => (
  <Prompt {...sale.ui.prompt} opened={sale.ui.prompt.opened}>
    <div>{t('You are about to upload offer in the name of customer')}</div>
    {sale.offers.isOfferSelected && (
      <div style={{ paddingTop: '5px' }}>
        {t('All information entered by customer will be overwritten')}
      </div>
    )}
    <div style={{ paddingTop: '5px' }}>{t('Would you like to continue?')}</div>
  </Prompt>
);

const GenericPrompt = ({ sale }) => (
  <Prompt {...sale.ui.prompt} opened={sale.ui.prompt.opened}></Prompt>
);

export { UploadOfferConfirmation, GenericPrompt };



// WEBPACK FOOTER //
// ./src/app/containers/Sale/Prompts/Prompts.jsx